import React from 'react'

import Header from './Header'
import Footer from './Footer'
import Zendesk from '../../router/ZendeskConfig'

const Layout = ({ children, noAuth, noFooter, childWrapperStyle, authscreen, showAddOrder, ...rest }) => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    return (
        <div
            className='pwa-layout'
        >
            <Zendesk defer />
            {authscreen ? null : <div className="pwa-header">
                <Header authscreen={authscreen} noAuth={noAuth} showAddOrder={showAddOrder} {...rest} />
            </div>}

            <main className="pwa-content" style={{
                ...childWrapperStyle
            }}>
                {children}
            </main>
            {(!noAuth && !noFooter) ? <div className="pwa-footer" style={{ paddingBottom: isStandalone ? '18px': '10px'}}><Footer /></div> : <></>}
        </div>
    )
}

export default Layout
